<template>
  <custom-vue-select
    id="section-select"
    label="Section"
    placeholder="Select Section"
    :rules="rules"
    :value-reducer="option=>option.id"
    :options="options"
    :disabled="!options.length"
    :data-provider="getSections"
    :selected.sync="sectionProxy"
  />
</template>

<script>
import CustomVueSelect from '@/components/FormInputs/CustomVueSelect.vue'
import Sections from '@/compositions/Tickets/Sections/SectionsApi'

export default {
  name: 'SectionSelect',
  components: { CustomVueSelect },
  props: {
    section: { type: Number, default: null },
    rules: { type: String, default: '' },
    selectedEventId: { type: Number, default: () => null },
  },
  data() {
    return {
      options: [],
    }
  },
  computed: {
    sectionProxy: {
      get() {
        return this.section
      },
      set(value) {
        this.$emit('update:section', value)
      },
    },
  },
  setup() {
    const { getSectionsRequest } = Sections()
    return { getSectionsRequest }
  },
  created() {
    this.getSections()
  },
  methods: {
    getSections(query) {
      this.getSectionsRequest({ name: query, event: this.selectedEventId, embed: 'tickets' }).then(res => {
        this.options = res.data.data
      })
    },
  },
}
</script>

<style>

</style>
